<template>
  <div>
    <a-list dense :height="screenHeight" class="role-list" id="scroller-box">
      <v-list-item-group v-model="selectedItem" color="primary" mandatory>
        <template v-for="(role, index) in rolesList">
          <v-list-item
            :key="role.id"
            :value="role.id"          
          >
            <v-list-item-avatar icon color="neutralGrayLight">
              <v-icon color="secondary darken-3">mdi-text-account</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ role.role }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index < rolesList.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </a-list>
  </div>
</template>

<script>
import AList from "@/wrapper-component/AList.vue";
export default {
  name: "RolesList",
  components: {
    AList
  },
  props: {
    value: {
      type: [String, Object],
      default: () => {},
    },
    rolesList: Array,
    screenHeight: Number,
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || null);
      },
    },
  },  
};
</script>

<style scoped>
.role-list { 
  overflow-y: auto;
  padding-top: 0px !important;
}

.in-person {
  color: var(--v-primary-base) !important;
}
.remotely {
  color: var(--v-warning-darken2) !important;
}
.absent {
  color: #bf360c !important;
}

.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 54px;
}
</style>